// Company routes come from the shared server identity contract, never a name.
export const companyDestination = reference => {
  if (reference && typeof reference === 'object') {
    const route = reference.route || reference.canonical_route;
    if (typeof route === 'string' && (/^\/company\/[^/?#]+$/.test(route) || route.startsWith('/search?'))) return route;
  }
  const term = typeof reference === 'string' ? reference : reference?.ticker || reference?.display_name || reference?.company_name || reference?.name || '';
  const params = new URLSearchParams({q: term, type: 'company'});
  if (reference?.watchlist_entry_id) params.set('pin_entry', reference.watchlist_entry_id);
  return `/search?${params}`;
};